<style>
.ivu-radio-group{
  display: block;
  margin-bottom: 10px;
}
</style>
<template>
	<Layout>
		<Content :style="{'padding': '10px'}">
			<Breadcrumb :style="{margin: '5px 0'}">
				<BreadcrumbItem>通用管理 > <b>兑换卡/优惠码</b></BreadcrumbItem>
			</Breadcrumb>
			<Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
				<span class="search_span_width">
					<span class="search_span_width_part1">名称：</span>
					<Input v-model="search.code_name" placeholder="请输入名称" :style="{'width':'110px'}"></Input>
				</span>
				<span class="search_span_width">
					<span class="search_span_width_part1">&nbsp;&nbsp;类型：</span>
					<Select v-model="search.code_type" clearable style="width:130px">
						<Option value="">请选择</Option>
						<Option value="1">兑换卡</Option>
						<Option value="2">优惠码</Option>
					</Select>
				</span>
				<span class="search_span_width">
					<span class="search_span_width_part1">&nbsp;&nbsp;渠道：</span>
					<Select v-model="search.channel" clearable style="width:130px">
						<Option v-for="(item,index) in channelList" :value="item.id" :key="index">{{ item.title }}</Option>
					</Select>
				</span>
				<Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList(1)">搜索</Button>
			</Card>
			<Card>
				<p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
					<span :style="{'text-align':'center','float':'left'}">
						<Button type='primary' :style="{'margin-left':'5px'}" @click="addModal()">添加兑换卡/优惠码</Button>
					</span>
				</p>
				<Card id="tableContent" >
					<Table :columns="tableColumns" row-key="id" update-show-children :data="recordList"></Table>
					<Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getList"/>
				</Card>
			</Card>
		</Content>
		<Modal v-model="showmodal" :footer-hide=true title="兑换卡/优惠码">
			<Form ref="info" :model="info" :label-width="80" :rules="editRule">
				<FormItem label="名称" prop="code_name">
					<Input v-model="info.code_name"/>
				</FormItem>
				<FormItem label="类型" prop="code_type">
					<RadioGroup v-model="info.code_type" @on-change="changeRelation($event, 1)">
						<Radio label="1">兑换卡</Radio>
						<Radio label="2">优惠码</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="渠道" prop="channel">
					<Select v-model="info.channel" style="width:160px" @on-change="changeRelation($event, 2)">
						<Option value="">请选择</Option>
						<Option v-for="(item,index) in channelList" :value="item.e_name" :key="index" :disabled="item.e_name=='all'?true:false">{{ item.title }}</Option>
					</Select>
				</FormItem>
				<FormItem label="关联信息" prop="relation_id">
					<Select v-model="info.relation_id" style="width:160px">
						<Option value="">请选择</Option>
						<Option v-for="(item,index) in relationList" :value="item.relation_id" :key="index">{{ item.relation_name }}</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
					<Button type="primary" @click="upsert()">提交</Button>
				</FormItem>
			</Form>
		</Modal>
	</Layout>
</template>
<script>
export default {
	data(){
		return {
			search:{
				code_name:"",
				code_type:"",
				channel:"",
			},
			info:{
				id:0,
				code_name:"",
				code_type:"1",
				relation_id:"",
				channel:""
			},
			sendinfo:{
				coupon_id:0,
				user_ids:[]
			},
			showmodal:false,
			loading2:false,
			relationList:[],
			showsmodal:false,
			channelList:[],
			recordList:[],
			recordTotal:0,
			page:1,
			editRule :{
				code_name:[
					{ required: true, message: '名称不能为空', trigger: 'blur' },
					{ max: 11, message: '名称长度不能超过11个字', trigger: 'blur' } 
				],
				code_type:[
					{ required: true, message: '请选择类型', trigger: 'change' }
				],
				channel: [
					{ required: true, message: '请选择渠道', trigger: 'blur' }
				],
				relation_id:[
					{ required: true,type: 'number', message: '请选择关联信息', trigger: 'blur' }
				]
			},
			tableColumns:[
				{ title: 'ID', key: 'id', align: 'center' },
				{ title: '名称', key: 'code_name', align: 'center' },
				{ title: '类型', key: 'code_type', align: 'center',
					render:(h,params) =>{
						if (params.row.code_type == 1) {
							var code_type = '兑换卡';
						}else {
							var code_type = '优惠码';
						}
						return h('span',{},code_type);
					}
				},
				{ title: '所属渠道', key: 'channel_name', align: 'center'},
				{ title: '操作', key: 'action', align: 'center',
					render: (h, params) => {
						let btns = []
						btns.push(
							h('Button', {
								props: { type: 'warning', size: 'small' },
								style: { marginRight: '5px', marginBottom: '5px'},
								on: {
									click: () => {        
										this.info.id = params.row.id;
										this.info.code_name = params.row.code_name;
										this.info.code_type = params.row.code_type.toString();
										this.info.relation_id = params.row.relation_id;
										this.info.channel = params.row.channel;
										this.getRelationList();
										this.showmodal = true;
									}
								}
							}, '编辑'),
						);
						btns.push(
							h('Button', {
								props: { type: 'error', size: 'small' },
								style: { marginRight: '5px', marginBottom: '5px'},
								on: {
									click: () => {
										this.del(params.row.id);
									}
								}
							}, '删除'),
						);
						btns.push(
							h('Button', {
								props: { type: 'success', size: 'small' },
								style: { marginRight: '5px', marginBottom: '5px'},
								on: {
									click: () => {
										this.$router.push({ path: `/common/couponCodeSnList?coupon_code_id=`+params.row.id });
									}
								}
							}, '查看卡密'),
						);
						return h("div", btns);
					}
				}
			],
		}
	},
	mounted:function(){
		this.getChannelList();
		this.getRelationList();
		this.getList();
	},
	computed:{},
	methods:{
		addModal(){
			this.info = {
				id:0,
				code_name:"",
				code_type:"1",
				relation_id:"",
				channel:""
			};
			this.showmodal = true;
		},
		closeModal(){
			this.showmodal = false;
			this.showsmodal = false;
		},
		getChannelList(){
			this.http1.get('/coupon_code/channelList').then(response=>{
				let data = response.data;
				if (data.code !== 0) {
					alert(data.message);
				} else {
					if (data.data) {
						this.channelList = data.data;
					}
				}
			}).catch(()=>{
				this.$Message.error('网络错误');
			});
		},
		getList(page = this.page){
			this.page = page;
			let p = {'page':page};
			let params = Object.assign(this.search, p);
			this.http1.get('/coupon_code/list', {params:params}).then(response=>{
				let data = response.data;
				if (data.code !== 0){
					alert(data.message);
				} else {
					this.recordList = data.data.list;
					this.recordTotal = data.data.total;
				}
			}).catch(()=>{
				this.$Message.error('网络错误');
			});
		},
		changeRelation(e, type){
			if (type == 1) {
				this.info.code_type = e;
			} else {
				this.info.channel = e;
			}
			this.getRelationList();
		},
		getRelationList(){
			if (this.info.code_type && this.info.channel) {
				this.http1.get('/coupon_code/relationList', {params:{'type':this.info.code_type, 'channel':this.info.channel}}).then(response=>{
					let data = response.data;
					if (data.code !== 0) {
						alert(data.message);
					} else {
						this.relationList = data.data.list;
					}
				}).catch(()=>{
					this.$Message.error('网络错误');
				});
			}
		},
		upsert(){
			this.$refs["info"].validate((valid) => {
				console.log(this.info);
				if(valid){
					this.http1.post('/coupon_code/upsert', this.info).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							alert(data.message);
						} else {
							this.getList(this.page);
							this.showmodal = false;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				}
			});
		},
		del(id){
			this.$Modal.confirm({
				content: '<p>请确认是否删除该兑换卡/优惠码？</p>',
				onOk: () => {
					this.showAllmodal = false;
					this.http1.post('/coupon_code/del', {id:id}).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							this.$Message.error(data.message);
							return false;
						} else {
							this.$Message.info('删除成功');
							this.getList(this.page);
							return true;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				},
			});
		}
	}
}
</script>
